import { Row, Card, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const Skills = () => {
    const { t } = useTranslation();

    return (
        <div style={{ padding: '2rem' }}>
            <h3 style={{ 
                marginBottom: '1.5rem', 
                fontWeight: 'bold', 
                textTransform: 'uppercase', 
                color: '#130164', 
                textAlign: 'center' 
            }}>
                {t('skills.title')}
            </h3>
            <Row>
                {t('skills.items', { returnObjects: true }).map((skill, index) => (        
                    <Col sm={6} xl={3} key={index} style={{ padding: '0.75rem' }}>
                        <Card 
                            style={{ 
                                background: 'linear-gradient(135deg, #130164, #38005e)', 
                                color: 'white', 
                                textAlign: 'center', 
                                fontWeight: 'bold', 
                                textTransform: 'uppercase',
                                border: 'none',
                                borderRadius: '10px',
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                                transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out'
                            }} 
                            onMouseOver={(e) => {
                                e.currentTarget.style.transform = 'scale(1.05)';
                                e.currentTarget.style.boxShadow = '0px 6px 15px rgba(0, 0, 0, 0.2)';
                            }}
                            onMouseOut={(e) => {
                                e.currentTarget.style.transform = 'scale(1)';
                                e.currentTarget.style.boxShadow = '0px 4px 10px rgba(0, 0, 0, 0.1)';
                            }}
                        >
                            <Card.Body>
                                <Card.Title style={{ fontSize: '1rem', letterSpacing: '0.5px' }}>
                                    {skill}
                                </Card.Title>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default Skills;
